export type FeedStatus = 'loading' | 'fresh' | 'stale' | 'unavailable';
// Readings are hourly; allow publication delay before flagging a stale feed.
export const STALE_AFTER_MS = 2 * 60 * 60 * 1000;

export function readingIsStale(timestamp: string | null, now: number): boolean {
  const time = timestamp ? Date.parse(timestamp) : NaN;
  return !Number.isFinite(time) || time > now + 5 * 60 * 1000 || now - time > STALE_AFTER_MS;
}

export function formatReadingTime(timestamp: string | null): string {
  if (!timestamp || !Number.isFinite(Date.parse(timestamp))) return 'Reading time unavailable';
  return (
    new Intl.DateTimeFormat('en-SG', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
      timeZone: 'Asia/Singapore',
    }).format(new Date(timestamp)) + ' SGT'
  );
}
